<template>
  <v-container class="formulario-wrapper pt-4 pt-sm-6 px-3 px-sm-6" fluid style="min-height: 80vh;">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8" class="mt-2">
        <v-card class="elevation-2 rounded-lg overflow-hidden">

          <v-card-text class="pa-4 pa-sm-6">
            <v-form ref="form" v-model="formValido">
              
              <!-- Seção 1: Identificação -->
              <div class="d-flex align-center mb-2">
                <v-icon small color="primary" class="mr-2">mdi-cog-outline</v-icon>
                <span class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 primary--text text--darken-1">
                  IDENTIFICAÇÃO DO EQUIPAMENTO
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>

              <v-row dense>
                <v-col cols="12" sm="8">
                  <v-text-field 
                    v-model="formData.descricao"
                    label="Descrição" 
                    outlined dense
                    hide-details="auto"
                    :rules="[v => !!v || 'Descrição é obrigatória']"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="formData.marca"
                    label="Marca"
                    outlined dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="formData.numSerie"
                    label="Número de Série"
                    outlined dense
                    hide-details="auto"
                    class="text-uppercase"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="formData.ids"
                    label="IDS / Tombamento"
                    outlined dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Seção 2: Dados Complementares -->
              <div class="d-flex align-center mt-3 mb-2">
                <v-icon small color="primary" class="mr-2">mdi-lock-outline</v-icon>
                <span class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 primary--text text--darken-1">
                  DADOS COMPLEMENTARES
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>

              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="formData.dadosComplementares"
                    label="Dados Complementares / Senha"
                    placeholder="Ex: Senha de acesso do sistema"
                    outlined dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Seção 3: Campos da Empresa -->
              <template v-if="empnomelivre1os || empnomelivre2os || empnomelivre3os">
                <div class="d-flex align-center mt-3 mb-2">
                  <v-icon small color="primary" class="mr-2">mdi-form-select</v-icon>
                  <span class="font-weight-bold text-subtitle-2 text-sm-subtitle-1 primary--text text--darken-1">
                    CAMPOS DA EMPRESA
                  </span>
                  <v-divider class="ml-3 divisor-secao"></v-divider>
                </div>

                <v-row dense>
                  <v-col cols="12" sm="4" v-if="empnomelivre1os">
                    <v-text-field v-model="formData.campoLivre1" :label="empnomelivre1os" outlined dense hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" v-if="empnomelivre2os">
                    <v-text-field v-model="formData.campoLivre2" :label="empnomelivre2os" outlined dense hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" v-if="empnomelivre3os">
                    <v-text-field v-model="formData.campoLivre3" :label="empnomelivre3os" outlined dense hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
              </template>

            </v-form>
          </v-card-text>

          <v-divider class="divisor-secao"></v-divider>

          <!-- Ações limpas -->
          <v-card-actions class="pa-4">
            <v-btn color="error" text @click="excluir" v-if="formData.idequipamento">
              Excluir
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="cancelar">Cancelar</v-btn>
            <v-btn color="primary" class="px-6" @click="salvar" :disabled="!formValido">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'CadastroEquipamento',

  data() {
    return {
      formValido: true,
      formData: {
        idequipamento: null,
        descricao: '',
        prsdescricaoequipamento: '',
        marca: '',
        prsmarcaequipamento: '',
        numSerie: '',
        prsnumeroserieequipamento: '',
        ids: '',
        prsidentificacaoidsequipamento: '',
        dadosComplementares: '',
        prsdadocomplementar: '',
        campoLivre1: '',
        prslivre1: '',
        campoLivre2: '',
        prslivre2: '',
        campoLivre3: '',
        prslivre3: ''
      }
    };
  },

  async created() {
    this.$root.$on('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
    if (!this.$store.getters['empresa/dados']) {
      await this.$store.dispatch('empresa/find').catch((err) => console.error('Erro ao buscar dados da empresa:', err));
    }
    this.carregarDados();
  },

  beforeDestroy() {
    this.$root.$off('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
  },

  computed: {
    nomeLivre1OS() {
      return this.$store.getters['empresa/nomeLivre1OS'];
    },
    nomeLivre2OS() {
      return this.$store.getters['empresa/nomeLivre2OS'];
    },
    nomeLivre3OS() {
      return this.$store.getters['empresa/nomeLivre3OS'];
    },
    empnomelivre1os() {
      return this.nomeLivre1OS;
    },
    empnomelivre2os() {
      return this.nomeLivre2OS;
    },
    empnomelivre3os() {
      return this.nomeLivre3OS;
    }
  },

  methods: {
    tratarVoltarAppBar() {
      this.cancelar();
    },

    onInputNumSerie() {
      this.formData.numSerie = (this.formData.numSerie || '').toUpperCase();
      this.formData.prsnumeroserieequipamento = this.formData.numSerie;
    },

    carregarDados() {
      let desc = '';
      let marca = '';
      let numSerie = '';
      let ids = '';
      let complemento = '';
      let livre1 = '';
      let livre2 = '';
      let livre3 = '';

      // 1. Tenta carregar do estado em edição da OS
      const osEmEdicaoStr = sessionStorage.getItem('osEmEdicao');
      if (osEmEdicaoStr) {
        try {
          const osEstado = JSON.parse(osEmEdicaoStr);
          if (osEstado && osEstado.formData) {
            const f = osEstado.formData;
            desc = f.prsdescricaoequipamento || f.DESCRICAOEQUIPAMENTO || f.DescricaoEquipamento || f.descricao || '';
            marca = f.prsmarcaequipamento || f.MARCAEQUIPAMENTO || f.MarcaEquipamento || f.marca || '';
            numSerie = f.prsnumeroserieequipamento || f.NUMEROSERIEEQUIPAMENTO || f.NumeroSerieEquipamento || f.numSerie || '';
            ids = f.prsidentificacaoidsequipamento || f.IDENTIFICACAOIDSEQUIPAMENTO || f.IdentificacaoIDSEquipamento || f.ids || '';
            complemento = f.prsdadocomplementar || f.DadoComplementar || f.dadocomplementar || f.dadosComplementares || '';
            livre1 = f.prslivre1 || f.Livre1 || f.livre1 || f.campoLivre1 || '';
            livre2 = f.prslivre2 || f.Livre2 || f.livre2 || f.campoLivre2 || '';
            livre3 = f.prslivre3 || f.Livre3 || f.livre3 || f.campoLivre3 || '';
          }
        } catch (e) {
          console.error('Erro ao ler osEmEdicao no equipamento:', e);
        }
      }

      // 2. Parâmetros de query (URL)
      const q = this.$route.query || {};
      if (!desc) desc = q.prsdescricaoequipamento || q.DESCRICAOEQUIPAMENTO || q.DescricaoEquipamento || q.descricao || '';
      if (!marca) marca = q.prsmarcaequipamento || q.MARCAEQUIPAMENTO || q.MarcaEquipamento || q.marca || '';
      if (!numSerie) numSerie = q.prsnumeroserieequipamento || q.NUMEROSERIEEQUIPAMENTO || q.NumeroSerieEquipamento || q.numSerie || '';
      if (!ids) ids = q.prsidentificacaoidsequipamento || q.IDENTIFICACAOIDSEQUIPAMENTO || q.IdentificacaoIDSEquipamento || q.ids || '';
      if (!complemento) complemento = q.prsdadocomplementar || q.DadoComplementar || q.dadocomplementar || q.dadosComplementares || '';
      if (!livre1) livre1 = q.prslivre1 || q.Livre1 || q.livre1 || q.campoLivre1 || '';
      if (!livre2) livre2 = q.prslivre2 || q.Livre2 || q.livre2 || q.campoLivre2 || '';
      if (!livre3) livre3 = q.prslivre3 || q.Livre3 || q.livre3 || q.campoLivre3 || '';

      this.formData.descricao = desc;
      this.formData.prsdescricaoequipamento = desc;
      this.formData.marca = marca;
      this.formData.prsmarcaequipamento = marca;
      this.formData.numSerie = numSerie;
      this.formData.prsnumeroserieequipamento = numSerie;
      this.formData.ids = ids;
      this.formData.prsidentificacaoidsequipamento = ids;
      this.formData.dadosComplementares = complemento;
      this.formData.prsdadocomplementar = complemento;
      this.formData.campoLivre1 = livre1;
      this.formData.prslivre1 = livre1;
      this.formData.campoLivre2 = livre2;
      this.formData.prslivre2 = livre2;
      this.formData.campoLivre3 = livre3;
      this.formData.prslivre3 = livre3;
    },

    salvar() {
      const descVal = this.formData.descricao || this.formData.prsdescricaoequipamento || '';
      const marcaVal = this.formData.marca || this.formData.prsmarcaequipamento || '';
      const numSerieVal = this.formData.numSerie || this.formData.prsnumeroserieequipamento || '';
      const idsVal = this.formData.ids || this.formData.prsidentificacaoidsequipamento || '';
      const compVal = this.formData.dadosComplementares || this.formData.prsdadocomplementar || '';
      const l1Val = this.formData.campoLivre1 || this.formData.prslivre1 || '';
      const l2Val = this.formData.campoLivre2 || this.formData.prslivre2 || '';
      const l3Val = this.formData.campoLivre3 || this.formData.prslivre3 || '';

      const retorno = {
        tipo: 'Equipamento',
        prsdescricaoequipamento: descVal || null,
        prsmarcaequipamento: marcaVal || null,
        prsnumeroserieequipamento: numSerieVal || null,
        prsidentificacaoidsequipamento: idsVal || null,
        prsdadocomplementar: compVal || null,
        prslivre1: l1Val || null,
        prslivre2: l2Val || null,
        prslivre3: l3Val || null,

        descricao: descVal,
        marca: marcaVal,
        numSerie: numSerieVal,
        ids: idsVal,
        dadosComplementares: compVal,
        campoLivre1: l1Val,
        campoLivre2: l2Val,
        campoLivre3: l3Val
      };

      sessionStorage.setItem('equipamento_selecionado_retorno', JSON.stringify(retorno));

      const osEmEdicaoStr = sessionStorage.getItem('osEmEdicao');
      if (osEmEdicaoStr) {
        try {
          const osEstado = JSON.parse(osEmEdicaoStr);
          if (osEstado && osEstado.formData) {
            osEstado.formData.prsdescricaoequipamento = descVal;
            osEstado.formData.descricao = descVal;
            osEstado.formData.prsmarcaequipamento = marcaVal;
            osEstado.formData.marca = marcaVal;
            osEstado.formData.prsnumeroserieequipamento = numSerieVal;
            osEstado.formData.numSerie = numSerieVal;
            osEstado.formData.prsidentificacaoidsequipamento = idsVal;
            osEstado.formData.ids = idsVal;
            osEstado.formData.prsdadocomplementar = compVal;
            osEstado.formData.dadosComplementares = compVal;
            osEstado.formData.prslivre1 = l1Val;
            osEstado.formData.campoLivre1 = l1Val;
            osEstado.formData.prslivre2 = l2Val;
            osEstado.formData.campoLivre2 = l2Val;
            osEstado.formData.prslivre3 = l3Val;
            osEstado.formData.campoLivre3 = l3Val;
            sessionStorage.setItem('osEmEdicao', JSON.stringify(osEstado));
          }
        } catch (e) {
          console.error('Erro ao atualizar osEmEdicao ao salvar equipamento:', e);
        }
      }

      this.$router.back();
    },

    excluir() {
      // Implementar exclusão se necessário
      this.cancelar();
    },

    cancelar() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.border-card {
  border: 1px solid #e0e0e0;
  overflow: hidden;
}

.section-title {
  letter-spacing: 0.5px;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}
</style>
